import styled from 'styled-components';

import { theme } from '../ui/theme';

export const TopBarButton = styled.button`
    height: 40px;
    width: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 100%;

    color: ${theme.colors.foreground.subtle};

    &:hover {
        color: ${theme.colors.foreground.default};
        background-color: ${theme.colors.background.inset};
    }
`;
